import React, {useContext} from 'react'
import { Link } from 'react-router-dom';
import './adminnavbar.css'
import { Context } from "../../context/Context";
import Avatar from 'react-avatar';

function AdminNavbar() {
    const {user} = useContext(Context);
    return (
        <div className="admin-navbar">
            <Link to="/admin" className="logo-link">
                <div className="logo"> mentorX | Admin</div>
            </Link>            
            <div>
           
            {user ?  <div className="nav-profile">
                <Avatar name={user.username} size="40" round={true} textSizeRatio={2.6} /> </div> :
            <Link to="/admin/login" className="logo-link">
            <div className="login-btn">Login</div>
           </Link>    
            }
            </div>
        </div>
    )
}

export default AdminNavbar
